export default __webpack_public_path__ + "static/media/SchrittFuerSchritt_mobil.5aac27ae.jpeg";